<cb-dialog class="flex-col" dialogHeading="{{ getDialogHeading() }}">
    <div class="dialog-container">
        <form #form="ngForm" class="form-container flex-col flex">
            <div class="flex-row flex-fill" *cbWaitFor="mappedItem">
                <div class="cb-margin flex-col flex-50">
                    <h3 class="mat-headline-6">Build Details</h3>
                    @if (buildTypeField.isVisible) {
                        <cb-select
                            label="Build Type"
                            name="buildType"
                            [options]="buildTypes"
                            [(ngModel)]="mappedItem.buildTypeId"
                            [required]="buildTypeField.isRequired"
                            [disabled]="!buildTypeField.isEditable"
                            (change)="buildTypeChanged()"
                            [readonly]="isReadonly"
                        >
                        </cb-select>
                    }
                    @if (jobNumberField.isVisible) {
                        <cb-input
                            name="jobNumber"
                            label="Job Number"
                            [(ngModel)]="mappedItem.jobNumber"
                            [readonly]="true"
                            [matTooltip]="'Job Number cannot be manually updated.'"
                        >
                        </cb-input>
                    }
                    <h3 class="mat-headline-6">Lot Details</h3>
                    @if (lotNumberField.isVisible) {
                        <cb-input
                            name="lotNumber"
                            label="Lot Number"
                            type="number"
                            [(ngModel)]="mappedItem.lotNumber"
                            [required]="lotNumberField.isRequired"
                            [disabled]="!lotNumberField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (roadDirectionField.isVisible) {
                        <cb-select
                            label="Road Direction"
                            name="roadDirection"
                            [options]="COMPASS_DIRECTION_TYPE_ENUM.toLookup()"
                            [(ngModel)]="mappedItem.roadDirection"
                            [required]="roadDirectionField.isRequired"
                            [disabled]="!roadDirectionField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-select>
                    }
                    @if (hasExternalLandVendorField.isVisible) {
                        <cb-checkbox
                            name="hasExternalLandVendor"
                            label="External Land Vendor"
                            [(ngModel)]="mappedItem.hasExternalLandVendor"
                            [required]="hasExternalLandVendorField.isRequired"
                            [disabled]="!hasExternalLandVendorField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-checkbox>
                    }
                    @if (lotPurchasePriceField.isVisible) {
                        <cb-currency
                            label="Lot Purchase Price"
                            name="purchasePrice"
                            [(ngModel)]="mappedItem.financials.purchasePrice"
                            [inclGst]="true"
                            [required]="lotPurchasePriceField.isRequired"
                            [disabled]="!lotPurchasePriceField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-currency>
                    }
                    @if (lotDepositField.isVisible) {
                        <cb-currency
                            label="Lot Deposit"
                            name="deposit"
                            [(ngModel)]="mappedItem.financials.deposit"
                            [inclGst]="false"
                            [required]="lotDepositField.isRequired"
                            [disabled]="!lotDepositField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-currency>
                    }
                    <h3 class="mat-headline-6">Sale Details</h3>
                    @if (landPriceField.isVisible) {
                        <cb-currency
                            label="Land Price"
                            name="landPrice"
                            [(ngModel)]="mappedItem.financials.landPrice"
                            [inclGst]="true"
                            [required]="landPriceField.isRequired"
                            [disabled]="!landPriceField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-currency>
                    }
                    @if (sellPriceField.isVisible) {
                        <cb-currency
                            label="Selling Price"
                            name="sellPrice"
                            [(ngModel)]="mappedItem.financials.sellPrice"
                            [inclGst]="true"
                            [required]="sellPriceField.isRequired"
                            [disabled]="!sellPriceField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-currency>
                    }
                    @if (lotHoldingDepositField.isVisible) {
                        <cb-currency
                            label="Lot Holding Deposit"
                            name="lotHoldingDeposit"
                            [(ngModel)]="mappedItem.lotHoldingDeposit"
                            [inclGst]="true"
                            [required]="lotHoldingDepositField.isRequired"
                            [disabled]="!lotHoldingDepositField.isEditable"
                            [readonly]="isReadonly"
                        >
                        </cb-currency>
                    }
                    <h3 class="mat-headline-6">Lot Description</h3>
                    <cb-text-area
                        name="lotHeading"
                        label="Header"
                        [(ngModel)]="mappedItem.lotHeading"
                        [maxlength]="1000"
                        [readonly]="isReadonly"
                    ></cb-text-area>
                    <cb-text-area
                        label="Description"
                        name="lotDescription"
                        [(ngModel)]="mappedItem.lotDescription"
                        [maxlength]="2000"
                        [readonly]="isReadonly"
                    ></cb-text-area>
                    <h3 class="mat-headline-6">Lot Amenities</h3>
                    @if (floorAreaField.isVisible) {
                        <cb-input
                            name="floorArea"
                            label="Floor Area"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.floorArea"
                            [required]="floorAreaField.isRequired"
                            [disabled]="!floorAreaField.isEditable"
                            svgIcon="floor-plan"
                            suffix="m&#178;"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (landAreaField.isVisible) {
                        <cb-input
                            name="landArea"
                            label="Land Area"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.landArea"
                            [required]="landAreaField.isRequired"
                            [disabled]="!landAreaField.isEditable"
                            svgIcon="floor-plan"
                            suffix="m&#178;"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (bedroomsField.isVisible) {
                        <cb-input
                            name="noBedrooms"
                            label="Bedroom"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.noBedrooms"
                            [required]="bedroomsField.isRequired"
                            [disabled]="!bedroomsField.isEditable"
                            svgIcon="bed"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (bathroomsField.isVisible) {
                        <cb-input
                            name="noBathrooms"
                            label="Bathroom"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.noBathrooms"
                            [required]="bathroomsField.isRequired"
                            [disabled]="!bathroomsField.isEditable"
                            icon="wc"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (livingRoomsField.isVisible) {
                        <cb-input
                            name="noLivingRooms"
                            label="Living"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.noLivingRooms"
                            [required]="livingRoomsField.isRequired"
                            [disabled]="!livingRoomsField.isEditable"
                            icon="weekend"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    @if (garagesField.isVisible) {
                        <cb-input
                            name="noGarages"
                            label="Garage"
                            type="number"
                            [(ngModel)]="mappedItem.amenities.noGarages"
                            [required]="garagesField.isRequired"
                            [disabled]="!garagesField.isEditable"
                            icon="home"
                            [readonly]="isReadonly"
                        >
                        </cb-input>
                    }
                    <cb-input
                        name="noCarparks"
                        label="Carpark"
                        type="number"
                        [(ngModel)]="mappedItem.amenities.noCarparks"
                        icon="directions_car"
                        [readonly]="isReadonly"
                    >
                    </cb-input>
                    <cb-input
                        name="noStudy"
                        label="Study"
                        type="number"
                        [(ngModel)]="mappedItem.amenities.noStudy"
                        icon="import_contacts"
                        [readonly]="isReadonly"
                    >
                    </cb-input>
                </div>
                <div class="cb-margin flex-col flex-50">
                    @if (lotAddressField.isVisible) {
                        <cb-address-new
                            [(ngModel)]="mappedItem.lotAddress"
                            addressTitle="Lot Address"
                            name="lotAddress"
                            [lockRegion]="true"
                            [required]="lotAddressField.isRequired"
                            [disabled]="!lotAddressField.isEditable"
                            [readonly]="isReadonly"
                            class="cb-margin-bottom"
                        >
                        </cb-address-new>
                    }
                    @if (
                        !mappedItem.hasUnits &&
                        (mappedItem.contractType === LOT_CONTRACT_TYPE_ENUM.HouseAndLand ||
                            mappedItem.contractType === LOT_CONTRACT_TYPE_ENUM.DesignAndLand)
                    ) {
                        <div class="flex-col">
                            <h3 class="mat-headline-6">Website Publishing</h3>
                            <cb-checkbox
                                name="isKiwibuild"
                                label="Kiwibuild"
                                [(ngModel)]="mappedItem.isKiwibuild"
                                [readonly]="isReadonly"
                            >
                            </cb-checkbox>
                            <cb-checkbox
                                name="isGrowhome"
                                label="Grow home"
                                [(ngModel)]="mappedItem.isGrowhome"
                                [readonly]="isReadonly"
                            >
                            </cb-checkbox>
                            <cb-checkbox
                                name="isKitset"
                                label="Kitset"
                                [(ngModel)]="mappedItem.isKitset"
                                [readonly]="isReadonly"
                            >
                            </cb-checkbox>
                            <cb-checkbox
                                name="isTransportable"
                                label="Transportable"
                                [(ngModel)]="mappedItem.isTransportable"
                                [readonly]="isReadonly"
                            >
                            </cb-checkbox>
                        </div>
                    }
                </div>
            </div>
        </form>
    </div>
    <div actions>
        @if (!isReadonly) {
            <button
                mat-raised-button
                color="primary"
                [disabled]="form.invalid || form.pristine"
                (cbClick)="save()"
                [clickLimit]="1"
            >
                Save
            </button>
        }
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
